import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { localizeAddress } from "../../lib/addressLang";

// منطق عنوان الفرع: تخزين نسختي العنوان عند وضع الدبوس + تبديل فوري بلا شبكة عند تغيير لغة الواجهة.
export const useBranchAddress = (form, setForm) => {
  const { i18n } = useTranslation();
  const firstLang = useRef(true);

  const pickLocation = ({ latitude, longitude, label, address_ar, address_en }) =>
    setForm((f) => ({
      ...f,
      latitude: latitude.toFixed(6),
      longitude: longitude.toFixed(6),
      address: label ?? f.address,
      address_ar: address_ar ?? f.address_ar,
      address_en: address_en ?? f.address_en,
    }));

  useEffect(() => {
    if (firstLang.current) {
      firstLang.current = false;
      return;
    }
    const lang = i18n.language;
    const key = lang === "ar" ? "address_ar" : "address_en";
    if (form[key]) {
      setForm((f) => ({ ...f, address: f[key] }));
      return;
    }
    if (!form.address) return;
    localizeAddress(form.address, lang)
      .then((v) => v && setForm((f) => ({ ...f, address: v, [key]: v })))
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language]);

  return { pickLocation };
};
